module.exports = __webpack_public_path__ + "static/media/electrical.9595deb8.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/icons/electrical.svg
// module id = 135
// module chunks = 0